// React
import { useState, useRef } from 'react'

// Mantine
import { ActionIcon, Tooltip, Button } from '@mantine/core'

// Icons (tabler.io)
import { IconReload, IconExternalLink } from '@tabler/icons-react'

// UI
import Box from './Box'

export default function Iframe({
    title,
    subtitle,
    rightSection,
    src,
    aspect,
    innerRef,
    fullHeight = false,
}) {
    const [isLoading, setIsLoading] = useState(true)

    const afterIframeLoad = () => {
        // Wait 1 more second to be sure the iframe is fully loaded
        setTimeout(() => setIsLoading(false), 1000)
    }

    // Reload iframe
    const iframeRef = useRef(null)

    const reloadIframe = () => {
        setIsLoading(true)
        iframeRef.current.src = iframeRef.current.src
    }

    const rightSectionWithReload = (
        <div className="flex items-center gap-3">
            {rightSection && rightSection}

            <Button
                component="a"
                href={'https://metabase.baltic-watches.com'}
                target="_blank"
                size="xs"
                variant="default"
                rightSection={<IconExternalLink size="1rem" />}
            >
                Ouvrir Metabase
            </Button>

            <Tooltip label="Rafraichir les données">
                <ActionIcon variant="default" onClick={reloadIframe}>
                    <IconReload size="1rem" />
                </ActionIcon>
            </Tooltip>
        </div>
    )

    return (
        <Box
            title={title}
            subtitle={subtitle}
            rightSection={rightSectionWithReload}
            innerRef={innerRef}
            fullHeight={fullHeight}
        >
            <div className="h-full" style={{ aspectRatio: aspect }}>
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white">
                        <span className="text-gray-400 text-sm">
                            Chargement du graphique...
                        </span>
                    </div>
                )}

                <iframe
                    src={src}
                    ref={iframeRef}
                    frameborder="0"
                    width="100%"
                    height="100%"
                    allowtransparency
                    onLoad={afterIframeLoad}
                ></iframe>
            </div>
        </Box>
    )
}
